export const DEFAULT_LANGUAGE = 'en-US' as const;

export const SUPPORTED_LANGUAGES = ['en-US', 'sv-SE', 'fi-FI', 'nb-NO', 'da-DK'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const TEAMS_LANGUAGE_MODE = 'teams' as const;

export type LanguagePreference = SupportedLanguage | typeof TEAMS_LANGUAGE_MODE;

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
  if (!value) {
    return false;
  }

  return SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
}

export function normalizeToSupportedLanguage(locale: string | null | undefined): SupportedLanguage {
  if (!locale) {
    return DEFAULT_LANGUAGE;
  }

  const normalized = locale.trim().toLowerCase();

  if (normalized.startsWith('sv')) {
    return 'sv-SE';
  }

  if (normalized.startsWith('fi')) {
    return 'fi-FI';
  }

  if (normalized.startsWith('nb') || normalized.startsWith('no') || normalized.startsWith('nn')) {
    return 'nb-NO';
  }

  if (normalized.startsWith('da')) {
    return 'da-DK';
  }

  if (normalized.startsWith('en')) {
    return 'en-US';
  }

  return DEFAULT_LANGUAGE;
}
